import React, { useEffect, useRef } from 'react'
import { Popper } from '@workday/canvas-kit-react/popup'
import { Toast } from '@workday/canvas-kit-react/toast'
import { checkIcon, exclamationCircleIcon } from '@workday/canvas-system-icons-web'
import { colors, space } from '@workday/canvas-kit-react/tokens'
import { Box } from '@workday/canvas-kit-react'

export interface ToastProps {
  good?: string[]
  bad?: string[]
  onClose: () => void
  secondsToDismiss?: number
}

export const ToastManager = (msg: ToastProps) => {
  const msgRef = useRef<any>(null)

  useEffect(() => {
    if ((msg.good?.length! > 0 || msg.bad?.length! > 0) && msgRef.current) {
      msgRef.current.scrollIntoView()
      if (!msg.secondsToDismiss || msg.secondsToDismiss > 0) {
        setTimeout(msg.onClose, 5000)
      }
    }
  }, [msg])

  const hasContent = (msg.good && msg.good.length > 0) || (msg.bad && msg.bad.length > 0)

  return (
    <Box position="sticky" top={0}>
      <Box ref={msgRef} height={0} />
      <Popper placement="bottom" open={hasContent} anchorElement={msgRef}>
        {msg.good && msg.good.length > 0 && (
          <Toast style={{ whiteSpace: 'pre-wrap' }} marginTop={space.xs}>
            <Toast.Icon icon={checkIcon} color="greenApple400" />
            <Toast.Body>
              {msg.good.map((m: string, idx: number) => {
                return <div key={idx} dangerouslySetInnerHTML={{ __html: m }} />
              })}
            </Toast.Body>
            <Toast.CloseIcon aria-label="Close notification" onClick={() => msg.onClose()} />
          </Toast>
        )}
        {msg.bad && msg.bad.length > 0 && (
          <Toast mode="alert" style={{ whiteSpace: 'pre-wrap' }} marginTop={space.xs}>
            <Toast.Icon icon={exclamationCircleIcon} color={colors.cinnamon500} />
            <Toast.Body>
              {msg.bad.map((m: string, idx: number) => {
                return <div key={idx} dangerouslySetInnerHTML={{ __html: m }} />
              })}
            </Toast.Body>
            <Toast.CloseIcon aria-label="Close notification" onClick={() => msg.onClose()} />
          </Toast>
        )}
      </Popper>
    </Box>
  )
}
